import {Autocomplete, Grid, Skeleton, TextField} from "@mui/material";

import { useFormContext } from "react-hook-form";
import { ControlledTextField } from "src/components/forms";

import {SyntheticEvent, useEffect, useState} from "react";
import {SolicitationFinancePreferencesFields} from "../../../../../types/financing/financingData";
import {HttpCacheOperation} from "../../../../../http/cache/httpCacheOperation";
import {
    OperationReasonDestination, OperationReasonDestinationFields
} from "../../../../../types/operationData";
import {
    EntityWithIdAndDescription,
    EntityWithIdAndDescriptionFields,
} from "../../../../../types/baseEntities";

const certElegibilidad = [
    'Si',
    'No'
]
interface OperationReasonOption {
    id: number;
    description: string;
    destination: string;
}

interface GroupedDestination {
    title: string,
    reasons: OperationReasonOption[]
}

interface ReasonDestinationProps {
    preReasonId?: number,
    preElegibility?: string
}


const ReasonDestination = ({preReasonId, preElegibility}: ReasonDestinationProps) => {

    const { control, watch, setValue, getValues } = useFormContext();
    const [elegibilidad, setElegibilidad] = useState<string | null>('No')
    const [reasonId, setReasonId] = useState<number | undefined>(preReasonId)
    const [destinations, setDestinations] = useState<EntityWithIdAndDescription[]>()
    const [reasonsDestination, setReasonsDestination] = useState<OperationReasonDestination[]>()
    const [groupedDestinations, setGroupedDestinations] = useState<GroupedDestination[]>()
    const handleInputChange = (event: SyntheticEvent<Element, Event>, newValue: string | null) => {
        setElegibilidad(newValue);
        if(elegibilidad === 'No'){
            setValue(SolicitationFinancePreferencesFields.EligibilityCode, '')
        }
    }
    
    
    useEffect(() => {
        HttpCacheOperation.getDestinations().then((r) => setDestinations(r))
        HttpCacheOperation.getReasonsDestination().then((r) => setReasonsDestination(r))
    }, [])
    
    useEffect(() => {
        if (destinations && reasonsDestination) {
            const group: GroupedDestination[] = destinations.map((dest) => {
                const relatedDestinationReasons: OperationReasonDestination[] = reasonsDestination.filter((reason) =>
                    dest[EntityWithIdAndDescriptionFields.Id] === reason[OperationReasonDestinationFields.OperationDestinationCode]
                );

                return {
                    title: dest[EntityWithIdAndDescriptionFields.Description],
                    reasons: relatedDestinationReasons.map((reason) => ({
                        id: reason[EntityWithIdAndDescriptionFields.Id],
                        description: reason[EntityWithIdAndDescriptionFields.Description],
                        destination: dest[EntityWithIdAndDescriptionFields.Description],
                    })),
                };
            });
            
            
            setGroupedDestinations(group)
        }
    }, [destinations, reasonsDestination])

    const watchDestinationCode = watch(SolicitationFinancePreferencesFields.DestinationReasonCode)

    useEffect(() => {
        setReasonId(getValues(SolicitationFinancePreferencesFields.DestinationReasonCode))
    }, [watchDestinationCode]);

    useEffect(() => {
        if (preElegibility) setElegibilidad('Si')
    }, [preElegibility]);

    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                {
                    groupedDestinations ? (
                        <Autocomplete
                            options={groupedDestinations.flatMap((group) => group.reasons)}
                            getOptionLabel={(option: OperationReasonOption) => option.description}
                            groupBy={(option: OperationReasonOption) => option.destination}
                            onChange={(event, newValue) => {
                                setValue(SolicitationFinancePreferencesFields.DestinationReasonCode, newValue ? newValue.id : null);
                            }}
                            value={groupedDestinations.flatMap((group) => group.reasons).find((option) => option.id === reasonId) || null}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Destino del financiamiento"
                                    size='small'
                                    name={SolicitationFinancePreferencesFields.DestinationReasonCode}
                                    required
                                />
                            }
                            size='small'
                            fullWidth
                        />
                    )
                        :
                        <Skeleton height={'45px'}/>
                }
            </Grid>
            <Grid item xs={12}>
                <ControlledTextField
                    control={control}
                    multiline
                    rows={5}
                    name={SolicitationFinancePreferencesFields.Comments}
                    label='Comentarios adicionales'
                    fullWidth
                />
            </Grid>
            <Grid item xs={12}>
                <ControlledTextField control={control}
                                     name={SolicitationFinancePreferencesFields.Line}
                                     label='Linea'
                                     fullWidth
                />
            </Grid>
            <Grid item xs={4}>
                <Autocomplete
                    options={certElegibilidad}
                    onChange={handleInputChange}
                    value={elegibilidad}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label="Certificado de elegibilidad"
                            size='small'
                        />
                    }
                    size='small'
                    fullWidth
                />
            </Grid>
            <Grid item xs={8}>
                {
                    elegibilidad === 'Si' &&
                    <ControlledTextField control={control}
                                         name={SolicitationFinancePreferencesFields.EligibilityCode}
                                         label='Código de elegibilidad'
                                         fullWidth
                                         required
                    />
                }
            </Grid>
        </Grid>
    )
}

export default ReasonDestination